import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Signin from "./Signin/Signin";
import Dashboard from "./Dashboard/Dashboard";
import Register from "./Register/Register";
import { notification } from "antd";
import { useAuth } from "../../provider/Auth.provider";
import { findUserByUID } from "../../service/findUsers/findUserByUID";
import SignFooter from "../../components/FlowComponents/SignFooter/SignFooter";

const Trainer = () => {
  const { user, loading } = useAuth();
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setIsRegistering(searchParams.get("action") === "register");
  }, [location.search]);

  useEffect(() => {
    const checkUserAccess = async () => {
      try {
        if (!user?.uid) {
          setIsSignedIn(false);
          return;
        }
        const userDetails = await findUserByUID(user.uid);
        if (userDetails?.userTypes === "club_trainer") {
          setIsSignedIn(true);
          if (location.pathname !== "/trainer/dashboard") {
            navigate("/trainer/dashboard", { replace: true });
          }
        }
      } catch (error) {
        notification.error({
          message: "Error",
          description: "An error occurred while checking user access",
          placement: "topRight",
          duration: 3,
        });
        setIsSignedIn(false);
      }
    };

    checkUserAccess();
  }, [user, navigate]);

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <>
      {/* {!isSignedIn ? (
        isRegistering ? <Register /> : <Signin />
      ) : (
        <Dashboard />
      )} */}

      {!isSignedIn ? (
        isRegistering ? (
          <>
            <Register />
            {/* <SignFooter /> */}
          </>
        ) : (
          <>
            <Signin />
            {/* <SignFooter /> */}
          </>
        )
      ) : (
        <Dashboard />
      )}
    </>
  );
};

export default Trainer;
